<template>
  <div class="compound public-content">
    <div class="breadcrumb">尺寸管理</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 10px 0 0 ">尺寸名称:</span>
        <el-input v-model="searchComposeSizeVo.sizeName" placeholder="请输入尺寸名称" clearable></el-input>
        <span style="margin:0 10px 0 20px ">页面类型:</span>
        <el-select v-model="searchComposeSizeVo.pageTypeCode" clearable placeholder="请选择">
          <el-option label="" value="">全部</el-option>
          <el-option v-for="item in $store.state.pms.pageTypeList" :key="item.id" :label="item.typeName" :value="item.typeCode"></el-option>
        </el-select>
        <span style="margin:0 10px 0 20px ">页面名称:</span>
        <el-input v-model="searchComposeSizeVo.pageName" clearable placeholder="请输入页面名称"></el-input>
      </div>
      <div>
        <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
        <el-button round type="primary" @click="pageManage()">页面管理</el-button>
        <el-button round type="primary" v-permission="'pts:admin:compose:size:add'" @click="newBuilt()">新建尺寸 </el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column label="尺寸名称" min-width="100px" prop="sizeName"></el-table-column>
          <el-table-column label="页面类型" min-width="100px">
            <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
          </el-table-column>
          <el-table-column label="页面名称" prop="pageName" min-width="100px"></el-table-column>
          <el-table-column label="宽高" min-width="100px">
            <template slot-scope="scope"> 宽度：{{ scope.row.sizeWidth }}mm<br> 高度：{{ scope.row.sizeHeight }}mm </template>
          </el-table-column>
          <el-table-column label="出血类型" prop="bleed.bleedName" min-width="100px"></el-table-column>
          <el-table-column label="出血" min-width="150px">
            <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{ scope.row.bleed.bleedRight }}mm <br>
              内侧：{{ scope.row.bleed.bleedIn }}mm </template>
          </el-table-column>
          <el-table-column label="折线" width="200px" prop="bleedName" min-width="100px">
            <template slot-scope="scope">
              <p v-for="(val, key) in scope.row.brokenLine" :key="key + val">{{ key === 'HORIZONTAL' ? '水平折线' : key === 'VERTICAL' ? '垂直折线' : '未定义字段' }}：<span v-for="item in val" :key="item">{{ item
              }}mm</span></p>
            </template>
          </el-table-column>
          <el-table-column label="码" min-width="100px">
            <template slot-scope="scope">
              <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100px">
            <template slot-scope="scope">
              <span class="color-blue" v-permission="'pts:admin:compose:size:detail'" @click="check(scope.row)">查看</span><br>
              <span class="color-blue" v-permission="'pts:admin:compose:size:detail'" @click="edit(scope.row)">编辑</span><br>
              <span v-permission="'pts:admin:compose:size:delete'" @click="deleteId = scope.row.id, deleteDialog = true" class="color-blue">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该尺寸？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteSize(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index'
import { sizeListPaging, pageTypeList, composeSizeDelete } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    VPagination
  },
  data () {
    return {
      deleteId: '',
      deleteDialog: false,
      searchComposeSizeVo: {
        pageName: '',
        pageTypeCode: '',
        sizeName: ''
      },
      composeList: [],
      keywords: '',
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      compoundType: [],
      tableData: [],
      pageTypeList: []
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.searchComposeSizeVo = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    this.getCompose()
    this.$store.dispatch('pms/getPageTypeList')
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    // 页面管理
    pageManage () {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchComposeSizeVo))
      this.$router.push('/pagetypeadmin')
    },
    // 新建尺寸
    newBuilt () {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchComposeSizeVo))
      this.$router.push('/createsize')
    },
    // 查看
    check (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchComposeSizeVo))
      this.$router.push({ path: '/checksize', query: { id: row.id } })
    },
    // 编辑
    edit (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchComposeSizeVo))
      this.$router.push({ path: '/createsize', query: { id: row.id } })
    },
    getPageTypeList () {
      pageTypeList().then(res => {
        if (res.data.success) {
          this.pageTypeList = res.data.data
        }
      })
    },
    onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.searchComposeSizeVo))
      }
      this.getCompose()
    },
    getCompose () {
      sizeListPaging({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, data: this.searchComposeSizeVo }).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getCompose(this.queryInfo)
          }
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records
          this.tableData.forEach(item => {
            item.brokenLine = {}
            item.composeSizeBrokenLineXrefList.forEach(val => {
              if (!item.brokenLine[val.brokenLineDirection]) {
                item.brokenLine[val.brokenLineDirection] = []
              }
              item.brokenLine[val.brokenLineDirection].push(val.brokenLineValue)
            })
          })
        }
      })
    },
    changeCompound (url) {
      this.$router.push(url)
    },
    deleteSize (id) {
      composeSizeDelete(id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.onSubmit()
          this.deleteDialog = false
        }
      })
    },
    deleteMenuOK () {
      this.getCompose()
    },
    addMenuOK () {
      this.getCompose()
    },
    changePage (val) {
      this.queryInfo = val
      this.getCompose(this.queryInfo)
    }
  }
}
</script>
<style scoped lang="less">
.compound {
  .add-category {
    justify-content: space-between;
  }

  .keywords {
    .el-input {
      width: 180px;
    }
  }
}
</style>
